import { SingleValue } from "react-select";
import { BinInfo } from "../staticInfo/state";
import { CleanImageType, CleaningDateList, CleaningDetailImageList, CleaningDetailRouteList, CleaningRouteList } from "./state";

export function initCleaningDateListAction(cleaningDateList:CleaningDateList[]){
    return {
        type: '@@cleaningState/initCleaningDateList' as const ,
        cleaningDateList
    }
}

export function initCleaningRouteListAction(cleaningRouteList:CleaningRouteList[]){
    return {
        type: '@@cleaningState/initCleaningRouteListAction' as const ,
        cleaningRouteList
    }
}

export function initCleaningDetailRouteListAction( cleaningDetailRouteList:CleaningDetailRouteList[]){
    return {
        type: '@@cleaningState/initCleaningDetailRouteList' as const ,
        cleaningDetailRouteList
    }
}


export function initCleaningDetailPhotoAction(cleaningDetailImageList:CleaningDetailImageList[]){
    return {
        type: '@@cleaningState/initCleaningDetailPhotoAction' as const ,
        cleaningDetailImageList    }
}

export function selectedCleaningDetailRouteAction(cleaningDetail:CleaningDetailRouteList){
    return {
        type: '@@cleaningState/selectedCleaningDetailRouteAction' as const ,
        cleaningDetail    
    }
}

export function changeCleaningBinInfoAction(binInfo:SingleValue<BinInfo>){
    return {
        type: '@@cleaningState/changeCleaningBinInfoAction' as const ,
        binInfo    
    }
}

export function ChangeAttendaceDateTimeAction(date:string){
    return {
        type: '@@cleaningState/ChangeAttendaceDateTimeAction' as const ,
        date    
    }
}

export function ChangeCleaningDateTimeAction(date: Date | moment.Moment){
    return {
        type: '@@cleaningState/ChangeCleaningDateTimeAction' as const ,
        date    
    }
}

export function ChangeClickCleaningDateFolderAction(clickDate:string){
     return {
        type: '@@cleaningState/ChangeClickCleaningDateFolderAction' as const ,
        clickDate    
    }
}

export function initCleaningImageTypeListAction(imagetypeList:CleanImageType[]){
    return {
          type: '@@cleaningState/initCleaningImageTypeListAction' as const ,
        imagetypeList 
    }
}

export function changePeopleCounterNumberAction(people_counter_number:string){
     return {
          type: '@@cleaningState/changePeopleCounterNumberAction' as const ,
        people_counter_number 
    }
}



export type CleaningAction =

|ReturnType<typeof initCleaningDateListAction>
|ReturnType<typeof initCleaningRouteListAction>
|ReturnType<typeof initCleaningDetailRouteListAction>
|ReturnType<typeof initCleaningDetailPhotoAction>
|ReturnType<typeof selectedCleaningDetailRouteAction>
|ReturnType<typeof changeCleaningBinInfoAction>
|ReturnType<typeof ChangeAttendaceDateTimeAction>
|ReturnType<typeof ChangeCleaningDateTimeAction>
|ReturnType<typeof ChangeClickCleaningDateFolderAction>
|ReturnType<typeof initCleaningImageTypeListAction>
|ReturnType<typeof changePeopleCounterNumberAction>


